import FireDepartmentListResultModelBase from '../_generated/modelBases/fire-department-list-result-model-base';

export default class FireDepartmentListResultModel extends FireDepartmentListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
